import { DeliveryMethod, OrderFields } from "../../../constants";
import type { TOrderFormData } from "../../../models/orderForm";
import type { TPrefillInfoParams } from "./types";

const getPrefillReceiverData = ({ affiliate, prefill, storedData }: TPrefillInfoParams): Partial<TOrderFormData> => {
  const prefillLocker =
    prefill?.deliveryMethod === DeliveryMethod.PudoToPudo || prefill?.deliveryMethod === DeliveryMethod.DoorToPudo
      ? prefill?.locker
      : null;

  const prefillAddress =
    prefill?.deliveryMethod === DeliveryMethod.PudoToDoor || prefill?.deliveryMethod === DeliveryMethod.DoorToDoor
      ? prefill?.address
      : null;

  const valuesToPrefill: Partial<TOrderFormData> = {
    [OrderFields.RECEIVER_NAME]: prefill?.recipient?.name ?? storedData?.[OrderFields.RECEIVER_NAME],
    [OrderFields.RECEIVER_PHONE_NUMBER]: prefill?.recipient?.phone ?? storedData?.[OrderFields.RECEIVER_PHONE_NUMBER],
    [OrderFields.RECEIVER_EMAIL]: prefill?.recipient?.email ?? storedData?.[OrderFields.RECEIVER_EMAIL],
    [OrderFields.RECEIVER_LOCKER]:
      prefillLocker?.lockerId ?? storedData?.[OrderFields.RECEIVER_LOCKER] ?? affiliate?.receiverLockerId,
    [OrderFields.RECEIVER_LOCKER_NAME]:
      prefillLocker?.locker ?? storedData?.[OrderFields.RECEIVER_LOCKER_NAME] ?? affiliate?.receiverLocker,
    [OrderFields.RECEIVER_STREET]: prefillAddress?.street ?? storedData?.[OrderFields.RECEIVER_STREET],
    [OrderFields.RECEIVER_HOUSE_NO]: prefillAddress?.streetNumber ?? storedData?.[OrderFields.RECEIVER_HOUSE_NO],
    [OrderFields.RECEIVER_FLAT_NO]: prefillAddress?.flatNo ?? storedData?.[OrderFields.RECEIVER_FLAT_NO],
    [OrderFields.RECEIVER_CITY]: prefillAddress?.city ?? storedData?.[OrderFields.RECEIVER_CITY],
    [OrderFields.RECEIVER_ZIP_CODE]: prefillAddress?.zip ?? storedData?.[OrderFields.RECEIVER_ZIP_CODE],
    [OrderFields.RECEIVER_COMMENTS]: storedData?.[OrderFields.RECEIVER_COMMENTS],
    [OrderFields.RECEIVER_ADDRESS_ID]: prefill?.id ?? storedData?.[OrderFields.RECEIVER_ADDRESS_ID],
  };
  return valuesToPrefill;
};
export default getPrefillReceiverData;
